import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api, parseErr, setTokenGetter } from '@/lib/api';

const AuthCtx = createContext(null);
const TOKEN_KEY = '32d.os.token';

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [user, setUser] = useState(null);
  const [meta, setMeta] = useState({ allowed_email_domain: '32december.design' });
  const [loading, setLoading] = useState(true);

  useEffect(() => { setTokenGetter(() => token); }, [token]);

  const refreshMe = useCallback(async () => {
    if (!token) { setUser(null); setLoading(false); return; }
    try {
      const r = await api.get('/auth/me');
      setUser(r.data.user);
    } catch {
      setToken(null);
      localStorage.removeItem(TOKEN_KEY);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => { refreshMe(); }, [refreshMe]);
  useEffect(() => { api.get('/meta').then(r => setMeta(r.data)).catch(() => {}); }, []);

  const login = async (email, password) => {
    const r = await api.post('/auth/login', { email, password });
    localStorage.setItem(TOKEN_KEY, r.data.token);
    setToken(r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };
  const register = async (email, password, name) => {
    const r = await api.post('/auth/register', { email, password, name });
    localStorage.setItem(TOKEN_KEY, r.data.token);
    setToken(r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };
  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setToken(null);
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ token, user, meta, loading, login, register, logout, refreshMe, parseErr }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
